export default __webpack_public_path__ + "static/media/11-maio.af639c52.jpg";